import topic from '../topic'
export const psotAPI = {
    getPsots: topic.psotTopic + '/get_psots',
    getPsotById: topic.psotTopic + '/get_psot_by_id',
    addPsot: topic.psotTopic + '/add_psot',
    editPsot: topic.psotTopic + '/edit_psot',
    deletePsotByIds: topic.psotTopic + '/delete_psot_by_ids'
}